import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    The numeric function SQR is a mathemathical function for square root of a number.
    When the term isn't a number, the BASIC error ?TYPE MISMATCH ERROR IN line occurrs. It can be only used number with values from 0 until 1e+38. 
    Then this area is out of range the BASIC error?OVERFLOW ERROR IN line is viewing. By negative values the BASIC error ?ILLEGAL QUANTITY ERROR IN 
    line occurs. When the numeric argument is absent, it appears a ?SYNTAX ERROR IN line. 
*/
export const sqr = async (args) => {
    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a number.
    if (isNaN(args)) {
        throw new errors.TypeMismatchError();
    }

    if (Math.abs(args) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Check for negative values.
    if (args < 0) {
        throw new errors.IllegalQuantityError();
    }

    // Calculate the square root.
    const result = Math.sqrt(args);

    // Check for overflow (if the result is not a finite number).
    if (Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the result.
    return result;
};